export default () => ({
  title: "HideDonorList",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
  },
});
